import { useOnboarding } from '@contexts/OnboardingContext'
import { useSession } from '@hooks/useSession'
import { Redirect } from 'expo-router'
import { isWeb } from 'tamagui'
import Home from './home'

export default function Index() {
  const { logged } = useSession()
  const { isOnboardingDone, isLoading } = useOnboarding()

  if (!isWeb && isLoading) {
    return null
  }

  if (!isWeb && !isOnboardingDone) {
    return <Redirect href="/onboarding" />
  }

  if (!logged) {
    return <Redirect href="/users/sign_in" />
  }

  return <Home />
}
